import API_URL from "../../constants/API_URL.js";
import { clientById } from "./getClientByIdAction";
import { message } from "antd";
export const LOGIN_IN_PROGRESS = "LOGIN_IN_PROGRESS";
export const LOGIN_FAILED = "LOGIN_FAILED";
export const LOGIN_SUCCESSFUL = "LOGIN_SUCCESSFUL";

const _ = require("lodash");
const axios = require("axios");

const loginSuccessfulAction = (data) => ({
  type: LOGIN_SUCCESSFUL,
  data,
});

const loginFailedAction = (data) => ({
  type: LOGIN_FAILED,
  data,
});
const getClientTaxId = (token) => {
  var authOptions = {
    method: "GET",
    url: API_URL + "clientByID",
    params: {
      clientId: token.clientId,
      lang: token.lang,
    },
    headers: {
      Authorization: token.tokenType + " " + token.accessToken,
      "Content-Type": "application/json",
    },
  };
  axios(authOptions).then(function(response) {
    if (response.data.object && response.data.object.tax) {
      localStorage.setItem("taxId", response.data.object.tax);
    }
  });
};
const saveCLientTaxInLocalStorage = (client, tokenType, accessToken) => {
  let authOptions = {
    method: "GET",
    url: API_URL + "clientByID",
    params: {
      clientId: client,
      lang: localStorage.getItem("lang"),
    },
    headers: {
      Authorization: tokenType + " " + accessToken,
      "Content-Type": "application/json",
    },
  };
  axios(authOptions).then((res) => {
    if (res.data.success && res.data.object && res.data.object.taxNo) {
      localStorage.setItem("taxNo", res.data.object.taxNo);
    } else {
      localStorage.setItem("taxNo", "");
    }
  });
};
export const loginThunk = (body) => (dispatch) => {
  console.log("body", body);
  dispatch({ type: LOGIN_IN_PROGRESS });
  const authOptions = {
    method: "POST",
    url: API_URL + "auth/signin",
    data: body,
  };
  // console.log(authOptions)
  axios(authOptions)
    .then(function(response) {
      localStorage.setItem("username", body.usernameOrEmail);
      getClientTaxId({
        tokenType: response.data.tokenType,
        accessToken: response.data.accessToken,
        clientId: response.data.clientId,
        lang: "END_DATE",
      });
      if (typeof response.data == "string") {
        message.error(response.data);
      } else {
        console.log(response.data);
        localStorage.setItem("accessToken", response.data.accessToken);
        localStorage.setItem("accessToken", response.data.accessToken);
        localStorage.setItem("accessToken", response.data.accessToken);
        localStorage.setItem("accessToken", response.data.accessToken);
        localStorage.setItem("accessToken", response.data.accessToken);
        localStorage.setItem("userId", response.data.userId);
        localStorage.setItem("tokenType", response.data.tokenType);
        localStorage.setItem("clientId", response.data.clientId);
        localStorage.setItem("posLogin", "false");
        localStorage.setItem("clientName", response.data.name);
        localStorage.setItem("clientlogo", response.data.clientlogo);
        localStorage.setItem("logoContentType", response.data.logoContentType);
        localStorage.setItem("isInclusiveTax", response.data.isInclusiveTax);
        localStorage.setItem("orderType", response.data.orderType);
        localStorage.setItem("printer", response.data.printer);
        localStorage.setItem("posOnlyUserLogin", false);

        saveCLientTaxInLocalStorage(
          response.data.clientId,
          response.data.tokenType,
          response.data.accessToken,
        );

        var screeensList = [...response.data.screensList];
        localStorage.setItem(
          "screen",
          JSON.stringify(response.data.screensList),
        );
        localStorage.setItem(
          "userRoleBasedScreensList",
          JSON.stringify(response.data.screensList),
        );
        dispatch(
          clientById(
            response.data.clientId,
            response.data.clientlogo,
            response.data.logoContentType,
          ),
        );

        var tokenType = response.data.tokenType;
        var accessToken = response.data.accessToken;
        const authOptions2 = {
          method: "GET",
          url: `${API_URL}parametersListByParaType`,
          params: {
            paraType: "SCREEN_GROUP",
            lang: localStorage.getItem("lang"),
          },
          headers: {
            Authorization: tokenType + " " + accessToken,
            "Content-Type": "application/json",
          },
        };
        let dataa = response.data;
        axios(authOptions2).then(function(response) {
          let array2 = [];
          for (let i = 0; i <= screeensList.length - 1; i++) {
            for (let j = 0; j <= response.data.length - 1; j++) {
              response.data[j].name = response.data[j].name.toLowerCase();
              if (screeensList[i].screenGroup === response.data[j].id) {
                let a = Object.assign(response.data[j]);
                let b = Object.assign(screeensList[i]);
                let c = { ...a, ...b };
                array2.push(c);
              }
            }
          }
          var grouped = "";
          grouped = _.mapValues(_.groupBy(array2, "screenGroup"), (clist) =>
            clist.map((array) => _.omit(array, "screenGroup")),
          );

          delete dataa.screensList;

          dataa.screensList = grouped;
          localStorage.setItem("userData", JSON.stringify(dataa));
          dispatch(loginSuccessfulAction(dataa));
        });
      }
    })
    .catch((err) => {
      if (JSON.parse(JSON.stringify(err)).response) {
        // console.log(err)
        message.error(JSON.parse(JSON.stringify(err)).response.data.message);
      } else {
        message.error("Connection Timed out");
      }
      dispatch(loginFailedAction(err));
    });
};
